import {z} from 'zod';

import {financingRateSchema} from './financingRateSchema';

/**
 * A financing variant always advertises the nominal rate and the APR together, so both interest
 * rates are required.
 */
export const financingCellFormSchema = z.object({
  nominalRate: financingRateSchema,
  apr: financingRateSchema,
  setActive: z.boolean(),
});

export type FinancingCellFormValues = z.infer<typeof financingCellFormSchema>;
